import { FronteggContext } from '@frontegg/rest-api';
import { Axios } from 'src/lib';
import {
  getOnboardingRolesSlice,
  getOnboardingSpecialtiesSlice,
} from 'src/modules/ambient_solo/store/slices/onboarding';
import { showToastError } from 'src/utilities/errortoast';
import { showToastSuccess } from 'src/utilities/toast';
import { axiosAdmin } from '../../../../lib/axios';
import {
  addPractitionerConfig,
  editPractitionerConfig,
  getAllPractitionerListConfig,
  getAutoGeneratePractitionerDetailsConfig,
  getFronteggRolesConfig,
  getPractitionerByIdConfig,
  getPractitionersOrgLevelConfig,
  getPromptByConditionConfig,
  offBoardPractitionerConfig,
  specialtyConditionConfig,
} from '../lib/practitioner.url';
import {
  getAllConditionsListSlice,
  superAdminLoadingSlice,
} from '../slices/condition.slice';
import {
  allDestinationPractitionerNamesOrgUuidsLoadingSlice,
  allDestinationPractitionerNamesOrgUuidsSlice,
  getAllPractitionersListSlice,
  getAutoGeneratePractitionerDetailsSlice,
  getFronteggRolesSlice,
  getPractitionerByIdSlice,
  getPractitionerFilterSlice,
  getPractitionersOrgLevelSlice,
  getFronteggRolesCurrentOrgSlice,
  getFronteggRolesAllSlice,
} from '../slices/practitioners.slice';
import { getPromptOverridesByIdSlice } from '../slices/promptoverrides.slice';
import { getPromptsByIdSlice } from '../slices/prompts.slice';

export const getAllPractitionerListAction = (org_uuid, practitioner_Id) => {
  return async (dispatch) => {
    dispatch(superAdminLoadingSlice(true));
    try {
      const { url } = getAllPractitionerListConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Impersonate-Org-UUID': `${org_uuid}`,
        'Headless-Mode': true,
      };
      const body = {
        org_uuid: org_uuid,
        practitioner_ids: practitioner_Id ? [practitioner_Id] : null,
      };
      const result = await Axios.post(url, body, { headers });
      const response = result?.data?.Practitioner_Conditions;
      if (result?.status === 200 && response) {
        dispatch(getAllPractitionersListSlice(response));
        dispatch(superAdminLoadingSlice(false));
        org_uuid &&
          !practitioner_Id &&
          dispatch(getPractitionerFilterSlice(response));
      }
    } catch (e) {
      dispatch(superAdminLoadingSlice(false));
      showToastError('No data available');
    }
  };
};

export const addPractitionerAction = (
  payload,
  setIsOpen,
  setIsOrganizationSelected,
  selectedOrganizationUUID,
  storeOrganizationUuid,
  setPractitionerOptions,
  setStoreMirrorPractitionerId,
  setIsShown,
  setSelectedPractitioner
) => {
  return async (dispatch) => {
    dispatch(superAdminLoadingSlice(true));
    try {
      const { url } = addPractitionerConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Impersonate-Org-UUID': `${storeOrganizationUuid}`,
        'Headless-Mode': true,
      };
      const result = await Axios.post(url, payload, { headers });
      if (result?.status === 200) {
        setIsOpen(false);
        setSelectedPractitioner(null);
        dispatch(getPractitionersOrgLevel(selectedOrganizationUUID));
        showToastSuccess('New user created');
        dispatch(getAllPractitionerListAction(selectedOrganizationUUID));
        setIsOrganizationSelected(false);
        dispatch(getPractitionerByIdSlice(null));
        setPractitionerOptions && setPractitionerOptions([]);
        setStoreMirrorPractitionerId && setStoreMirrorPractitionerId(null);
        setIsShown && setIsShown(false);
      }
    } catch (e) {
      if (e?.response?.status === 404) {
        showToastError('Practitioner already exist');
      } else {
        showToastError('Error occurred');
      }
      dispatch(superAdminLoadingSlice(false));
    }
  };
};

export const getPractitionerByIdAction = (
  id,
  setEditModalOpen,
  setConditionOptions,
  selectedOrganizationUUID
) => {
  return async (dispatch) => {
    dispatch(superAdminLoadingSlice(true));
    try {
      const { url } = getPractitionerByIdConfig(id);
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Impersonate-Org-UUID': `${selectedOrganizationUUID}`,
        'Headless-Mode': true,
      };
      const result = await Axios.get(url, { headers });
      const response = result?.data;
      if (result?.status === 200 && response) {
        dispatch(getPractitionerByIdSlice(response));
        dispatch(superAdminLoadingSlice(false));
        setEditModalOpen && setEditModalOpen(true);
        setConditionOptions && setConditionOptions(true);
      }
    } catch (e) {
      dispatch(superAdminLoadingSlice(false));
      showToastError('Error occurred');
    }
  };
};

export const editPractitionerAction = (
  payload,
  setIsOpen,
  selectedOrganizationUUID,
  setSelectedPractitioner
) => {
  return async (dispatch) => {
    try {
      const { url } = editPractitionerConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Impersonate-Org-UUID': `${selectedOrganizationUUID}`,
        'Headless-Mode': true,
      };
      const result = await Axios.put(url, payload, { headers });
      if (result?.status === 200) {
        setIsOpen(false);
        setSelectedPractitioner(null);
        showToastSuccess('User updated successfully');
        dispatch(getAllPractitionerListAction(selectedOrganizationUUID));
      }
    } catch (e) {
      dispatch(superAdminLoadingSlice(false));
      showToastError('Error occurred');
    }
  };
};

export const getPractitionersOrgLevel = (org_uuid) => {
  return async (dispatch) => {
    try {
      const { url } = getPractitionersOrgLevelConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Impersonate-Org-UUID': ` ${org_uuid}`,
        'Headless-Mode': true,
      };
      const payload = {
        org_uuid: org_uuid,
      };
      const result = await Axios.post(url, payload, { headers });
      if (result?.status === 200) {
        dispatch(
          getPractitionersOrgLevelSlice(result?.data?.Practitioners_data)
        );
      }
    } catch (e) {
      dispatch(superAdminLoadingSlice(false));
      showToastError('Error occurred');
    }
  };
};

export const getPromptByConditionAction = (
  selectedOrganizationUUID,
  payload
) => {
  return async (dispatch) => {
    dispatch(superAdminLoadingSlice(true));
    try {
      const { url } = getPromptByConditionConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Impersonate-Org-UUID': ` ${selectedOrganizationUUID}`,
        'Headless-Mode': true,
      };
      const result = await Axios.post(url, payload, { headers });
      const response = result?.data;
      if (result?.status === 200 && response) {
        dispatch(superAdminLoadingSlice(false));
        if (response?.label === 'global') {
          dispatch(getPromptsByIdSlice(response));
        } else if (response?.label === 'prompt_override') {
          dispatch(getPromptOverridesByIdSlice(response));
        } else if (!response?.label) {
          showToastSuccess('No prompt available for this condition');
        }
      }
    } catch (e) {
      dispatch(superAdminLoadingSlice(false));
      showToastError('Error occurred');
    }
  };
};

export const organizationRoles = () => {
  return async (dispatch) => {
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${FronteggContext.getAccessToken()}`,
      'Headless-Mode': true,
    };
    const result = await Axios.get(`/roles`, { headers });
    const response = result?.data?.roles;
    if (result?.status === 200 && response) {
      dispatch(getOnboardingRolesSlice(response));
    }
  };
};

export const organizationSpecialties = () => {
  return async (dispatch) => {
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${FronteggContext.getAccessToken()}`,
      'Headless-Mode': true,
    };
    const result = await Axios.get(`/specialties`, { headers });
    const response = result?.data?.specialties;
    if (result?.status === 200 && response) {
      dispatch(getOnboardingSpecialtiesSlice(response));
    }
  };
};

export const autoGeneratePractitionerDetailsAction = (
  practitioner_Id,
  selectedOrganizationUUID,
  setFieldValue,
  conditionOptions,
  fronteggRoleOptions
) => {
  return async (dispatch) => {
    try {
      const { url } = getAutoGeneratePractitionerDetailsConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Impersonate-Org-UUID': ` ${selectedOrganizationUUID}`,
        'Headless-Mode': true,
      };
      const payload = {
        practitioner_id: practitioner_Id,
      };
      const result = await Axios.post(url, payload, { headers });
      const response = result?.data;
      const specialtyId = response?.specialty_details?.specialty_id;
      if (result?.status === 200 && response) {
        dispatch(getAutoGeneratePractitionerDetailsSlice(response));
        setFieldValue('get_role', response?.role_details?.role_id);
        setFieldValue('get_primary_specialty', specialtyId);
        if (response?.condition_details?.length > 0) {
          const conditionIds = [
            ...new Set(
              response.condition_details.map(
                (condition) => condition.condition_id
              )
            ),
          ];
          conditionOptions?.length > 0 &&
            setFieldValue('condition_id', conditionIds);
        }
        if (
          response?.frontegg_roles?.length > 0 &&
          fronteggRoleOptions?.length > 0
        ) {
          let fronteggRoles = [];
          fronteggRoleOptions.forEach((role) => {
            if (response?.frontegg_roles?.includes(role?.id)) {
              fronteggRoles.push(role?.name);
            }
          });
          setFieldValue('frontegg_roles', fronteggRoles);
        }
      }
    } catch (e) {
      showToastError('Error occurred');
    }
  };
};

export const specialtyConditionApi = (specialty_id, condition_id) => {
  return async (dispatch) => {
    dispatch(superAdminLoadingSlice(true));
    try {
      const { url } = specialtyConditionConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const payload = {
        specialty_id: specialty_id,
        condition_id: condition_id,
      };
      const result = await Axios.post(url, payload, { headers });
      const response = result?.data;
      if (result?.status === 200 && response) {
        dispatch(getAllConditionsListSlice(response));
        dispatch(superAdminLoadingSlice(false));
      }
    } catch (e) {
      dispatch(superAdminLoadingSlice(false));
      showToastError('An error occurred');
    }
  };
};

export const offboardUserFromOrganisation = (practitionerId, orgUuid) => {
  return async (dispatch) => {
    dispatch(superAdminLoadingSlice(true));
    try {
      const { url } = offBoardPractitionerConfig(practitionerId);
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Impersonate-Org-UUID': `${orgUuid}`,
        'Headless-Mode': true,
      };
      const result = await Axios.put(url, undefined, { headers });
      if (result?.status === 200) {
        dispatch(superAdminLoadingSlice(false));
        showToastSuccess('Practitioner deleted successfully');
        dispatch(getPractitionersOrgLevel(orgUuid));
      }
    } catch (e) {
      dispatch(superAdminLoadingSlice(false));
      showToastError('Error occurred');
    }
  };
};

export const getFronteggRoles = (uuid) => {
  return async (dispatch) => {
    try {
      const { url } = getFronteggRolesConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Impersonate-Org-UUID': `${uuid}`,
        'Headless-Mode': true,
      };
      const result = await Axios.get(url, { headers });
      if (result?.status === 200) {
        dispatch(getFronteggRolesSlice(result?.data));
      }
    } catch (e) {
      showToastError('Error occurred');
    }
  };
};

export const getFronteggRolesCurrentOrg = (_uuid) => {
  return async (dispatch) => {
    try {
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const result = await Axios.get('/frontegg_roles/current_org', {
        headers,
      });
      if (result?.status === 200) {
        dispatch(getFronteggRolesCurrentOrgSlice(result?.data));
      }
    } catch (e) {
      showToastError('Error occurred');
    }
  };
};

export const getAllFronteggRoles = () => {
  return async (dispatch) => {
    try {
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };
      const result = await Axios.get('/frontegg_roles/all', {
        headers,
      });
      if (result?.status === 200) {
        dispatch(getFronteggRolesAllSlice(result?.data));
      }
    } catch (e) {
      showToastError('Error occurred');
    }
  };
};

export const listPractitionersFromAllOrgs = (org_uuids, _type) => {
  return async (dispatch) => {
    try {
      dispatch(allDestinationPractitionerNamesOrgUuidsLoadingSlice(true));
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${FronteggContext.getAccessToken()}`,
      };
      const result = await axiosAdmin.post(
        `/practitioner/orgs/all`,
        { org_uuids },
        { headers }
      );
      const response = result?.data;
      if (result?.status === 200) {
        dispatch(
          allDestinationPractitionerNamesOrgUuidsSlice(
            response?.practitioners_data
          )
        );
      } else {
        dispatch(allDestinationPractitionerNamesOrgUuidsSlice([]));
        showToastError('Failed to fetch practitioners');
      }
    } catch (error) {
      console.log(error);
      showToastError('Failed to fetch practitioners');
    } finally {
      dispatch(allDestinationPractitionerNamesOrgUuidsLoadingSlice(false));
    }
  };
};
